export default "__VITE_ASSET__DnE$tYt0__"